import React, { useContext } from 'react';
import FooterLogo from './FooterLogo';
import { Box, makeStyles } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import AppContext from '../../contextProvider/AppContextProvider/AppContext';
import { THEME_TYPES } from '../../../constants/ThemeOptions';
import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btnRoot: {
    [theme.breakpoints.down('xs')]: {
      padding: '6px 12px',
      fontSize: 11,
    },
  },
}));

const Footer = props => {
  const classes = useStyles();
  const { themeType } = useContext(AppContext);
  const date = toLocalISO();

  return (
    <Box className={classes.root} {...props}>
      <Box
        display="flex"
        alignItems="center"
        style={{ display: 'flex', justifyContent: 'left', alignItems: 'center', flexDirection: 'row' }}>
        <Hidden xsDown>
          <FooterLogo color={themeType === THEME_TYPES.DARK ? 'white' : ''} style={{ width: '100px' }} />
        </Hidden>
        <Box fontSize={{ xs: 12, sm: 14 }} component="p" color="text.disabled" style={{ margin: '0px' }}>
          Copyright Dscission © {date.getFullYear()}
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
